/* eslint-disable react/prop-types */
import React from 'react'
import {
  Box, Button, CircularProgress, makeStyles, Typography,
} from '@material-ui/core'
// import icons from '@assets/icons'
import application from '@config/application'
import { Link } from 'react-router-dom'
import { useFormContext } from 'react-hook-form'
// import { matchDomain } from '@config/helpers'
import FieldTextPassword from './CustomFields/FieldTextPassword'
import FieldTextEmail from './CustomFields/FieldTextEmail'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    position: 'fixed',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'linear-gradient(180deg, #FFB4AC 0%, #EF6C57 100%)',
  },
  formContainer: {
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    padding: 60,
    width: 500,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '60px 20px 60px 20px',
    },
  },
  shape: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    bottom: 0,
  },
  logo: {
    marginBottom: 28,
  },
  title: {
    fontWeight: 600,
    marginBottom: 20,
    fontSize: 20,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  forgotPassword: {
    fontWeight: 'bold',
    textDecoration: 'none',
    margin: '10px 0px 10px 0px ',
  },
  socialIcon: {
    height: 26,
    width: 26,
    margin: theme.spacing(1),
  },
  txRegister: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  txNoAccount: {
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    marginTop: theme.spacing(4),
  },
  txFooter: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
  version: {
    // color: '#fff',
    color: theme.palette.primary.main,
    position: 'absolute',
    right: 20,
    bottom: 20,
    // '@media (max-height: 630px)': { color: theme.palette.primary.main },
  },
}))

const LoginForm = (props) => {
  const classes = useStyles()
  const {
    control, register, errors, handleSubmit, watch,
  } = useFormContext()

  const {
    isSubmitting, onSubmit, disableRegisterButton, title, affiliate,
  } = props

  return (
    <Box className={classes.formContainer}>
      {/* {
        matchDomain(window.location.hostname)
        && (
        <img
          src={icons.AppLogo}
          alt="logo"
          className={classes.logo}
          width={128}
          height={100}
        />
        )
} */}
      <div style={{ width: 110, height: 138 }} />
      <Typography variant="h6" className={classes.title}>
        {title || 'Masuk Ke Dashboard'}
      </Typography>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <FieldTextEmail
          errors={errors}
          control={control}
          watch={watch}
          defaultValue=""
          name="username"
          placeholder="Email"
          register={register}
          isSubmitting={isSubmitting}
        />
        <FieldTextPassword
          name="password"
          control={control}
          defaultValue=""
          errors={errors}
          isSubmitting={isSubmitting}
          register={register}
          placeholder="Password"
        />

        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={isSubmitting}
        >
          { isSubmitting ? <CircularProgress size={24} color="secondary" /> : 'Masuk'}
        </Button>
        { !disableRegisterButton && (
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={isSubmitting}
          component={Link}
          style={{ marginTop: 8 }}
          to={`${application.prefix}/register`}
        >
          Register
        </Button>
        )}
        <Button
          color="primary"
          disabled={isSubmitting}
          style={{ marginTop: 18 }}
          component={Link}
          to={`${application.prefix}/forgot-password`}
        >
          Lupa Kata Sandi?
        </Button>
        {
          affiliate && (
            <Button
              color="primary"
              disabled={isSubmitting}
              style={{ marginTop: 18 }}
              component={Link}
              to={`${application.prefix}/register/affiliate`}
            >
              Daftar Affiliate
            </Button>
          )
        }
      </form>
      <div className={classes.version}>v1.0.0-rc1</div>
    </Box>
  )
}

export default LoginForm
